import React from 'react';
import { Link } from 'react-router-dom';

// Link for admin-entered URLs: store pages ("/collections/kurtas") use the router,
// other websites open in a new tab, and an empty link renders a plain element.
const SmartLink = ({ to, className, children, fallbackTag: Fallback = 'div', ...rest }) => {
  if (!to) return <Fallback className={className} {...rest}>{children}</Fallback>;
  if (/^https?:\/\//i.test(to)) {
    return (
      <a href={to} className={className} target="_blank" rel="noopener noreferrer" {...rest}>
        {children}
      </a>
    );
  }
  return <Link to={to} className={className} {...rest}>{children}</Link>;
};

export default SmartLink;
